export function IsNullOrUndefined(value): boolean {

    return value === null || value === undefined;
}
